<script>
import _ from 'lodash';

import {
  authComputed,
  authMethods,
  clientComputed,
  clientMethods,
  trainerComputed,
  orgComputed,
  orgMethods,
} from '@state/helpers';

export default {
  name: 'PersonalAllSetMobile',
  components: {},
  data() {
    return {
      updatingClient: false,
    };
  },
  async mounted() {
    await this.getOrgDetails(this.orgId);

    this.updatingClient = true;

    const payload = {
      client: {
        completedOnBoarding: true,
      },
    };
    const response = await this.updateClient({ clientId: this.clientId, trainerId: this.trainerId, payload });

    if (response.success === false) {
      console.error('response: ', response);
    } else {
      const updatedUser = _.cloneDeep(this.currentUser);
      updatedUser.user = response.client;
      this.setCurrentUser(updatedUser);
    }

    this.updatingClient = false;
  },
  methods: {
    ...authMethods,
    ...clientMethods,
    ...orgMethods,
    gotoAppStore() {
      window.open(this.storeUrls.appleUrl, '_blank');
    },
    gotoPlayStore() {
      window.open(this.storeUrls.googleUrl, '_blank');
    },
  },
  computed: {
    ...authComputed,
    ...clientComputed,
    ...trainerComputed,
    ...orgComputed,
    isPMEO() {
      return process.env.VUE_APP_ORG_ID === '618183d65e84466f63c38878';
    },
  },
};
</script>

<template>
  <div class="container">
    <div class="header">
      <BaseProgressBar :limit="7" :progress="7" class="base-progress-bar" />
      <div class="title">
        <div class="circle">
          <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="isPMEO" v-bind:class="'icon-check'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M33 66c18.225 0 33-14.775 33-33S51.225 0 33 0 0 14.775 0 33s14.775 33 33 33z" fill="url(#paint0_linear)" fill-opacity=".6"/><path d="M17.368 33.55l4.466-5.321 8.645 7.255 15.748-18.116 5.243 4.56L35.803 39.95l-4.466 5.322L17.368 33.55z" fill="#fff"/><defs><linearGradient id="paint0_linear" x1="33" y1="0" x2="33" y2="66" gradientUnits="userSpaceOnUse"><stop stop-color="#ff6e69"/><stop offset="1" stop-color="#ff6e69"/></linearGradient></defs></svg>
          <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:class="'icon-check'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M33 66c18.225 0 33-14.775 33-33S51.225 0 33 0 0 14.775 0 33s14.775 33 33 33z" fill="url(#paint0_linear)" fill-opacity=".6"/><path d="M17.368 33.55l4.466-5.321 8.645 7.255 15.748-18.116 5.243 4.56L35.803 39.95l-4.466 5.322L17.368 33.55z" fill="#fff"/><defs><linearGradient id="paint0_linear" x1="33" y1="0" x2="33" y2="66" gradientUnits="userSpaceOnUse"><stop stop-color="#55BCF5"/><stop offset="1" stop-color="#3E4FE2"/></linearGradient></defs></svg>
        </div>
        <h1>
          You’re all set!
        </h1>
      </div>
      <div class="subtitle">
        <p>
          Awesome, now on to the fun part! I’m getting your new program set up.
        </p>
        <br />
        <p>
          In the mean time, you can download the IOS or Android app or get familiar with the app right here on the web.
        </p>
      </div>
      <div class="buttons">
        <BaseButton class="large-transparent" @event="$router.push({ name: 'home' })" :disabled="updatingClient">
          Continue
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.circle {
  margin: auto;
  width: 70px;
}

.container {
  background: #1c1c1ca0;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  width: 100%;
  .header {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin: 0;
    text-align: start;
    width: 100%;
    .base-progress-bar {
      margin-left: 6.4%;
      top: 7.2%;
      width: 87.2%;
    }

    .title {
      align-self: center;
      font-family: $base-font-family;
      font-size: 18px;
      font-style: normal;
      font-weight: bold;
      margin: auto;
      padding-top: 30%;
      width: 100%;

      h1 {
        color: white;
        font-size: 36px;
        letter-spacing: -0.761905px;
        line-height: 42px;
        margin-bottom: 10px;
        margin-top: 2px;
        opacity: 0.9;
        text-align: center;
      }
    }

    .subtitle {
      align-self: center;
      font-family: $secondary-font-family;
      font-size: 16px;
      p {
        color: white;
        line-height: 23px;
        margin: 0 30px 0 30px;
        mix-blend-mode: normal;
        opacity: 0.9;
        text-align: center;
      }
    }
  }

  .buttons {
    display: flex;
    flex-direction: column;
    height: 40%;
    justify-content: center;
    margin-top: auto !important;
    position: relative;
    .apple-app-store {
      background: url('../../../../assets/store-badges/App_Store_Badge_US-UK_RGB_blk.svg') center no-repeat;
      background-size: contain;
      height: 60px;
      margin: 0 auto;
      width: 200px;
    }

    .google-play-store {
      background: url('../../../../assets/store-badges/google-play-badge-dark.png') center no-repeat;
      background-size: contain;
      height: 53px;
      margin: 20px auto 0;
      width: 200px;
    }
    .large-transparent {
      background-color: transparent;
      border: 1px white solid;
      line-height: unset;
      margin-top: 6%;
      transition-duration: 0.3s;
      width: 100%;
      @include calc-font-size(1.4);
      &:hover {
        background-color: rgba(#1c1c1c, 0.3);
        border: 1px rgba(#1c1c1c, 0.3) solid;
      }
    }
  }
}
</style>
